import { IBaseService } from '@/bundles/App/interfaces';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';
import { IAddToGroupDto, ILoadGroupItemsDto } from '@/bundles/ActivityGroup/dto';

export default class ActivityGroupService implements IBaseService<any> {
  errorMapper: ErrorMapper;
  transport: HttpTransport;

  constructor (props: IBaseService<any>) {
    this.errorMapper = props.errorMapper;
    this.transport = props.transport;
  }

  async addToGroup(group: ActivityGroupType, payload: IAddToGroupDto) {
    try {
      await this.transport.post(`/activity-group/${group}/add-to-group`, payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async loadGroupItems(group: ActivityGroupType, queryParams: ILoadGroupItemsDto) {
    try {
      return await this.transport.get(`/activity-group/${group}/load`, queryParams);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async deleteFromGroup(id: number) {
    try {
      await this.transport.delete(`/activity-group/${id}/`);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async bulkOrderUpdate(payload: { items: { id: number; order: number }[] }) {
    try {
      await this.transport.patch('/activity-group/bulk-order-update', payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
